var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFcTv({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4 48H1.6C0.64 48 0 47.36 0 46.4V1.6C0 0.64 0.64 0 1.6 0H78.4C79.36 0 80 0.64 80 1.6V46.4C80 47.36 79.36 48 78.4 48ZM3.2 44.8H76.8V3.2H3.2V44.8Z",
    fill: "#0088E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51.2012H16V54.4012H64V51.2012Z",
    fill: "#0088E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFcTv);
export default __webpack_public_path__ + "static/media/fc-tv.840e47d845c73f76ccedc4189eebf918.svg";
export { ForwardRef as ReactComponent };